/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SaveArticle/theme';

export const SaveArticleTheme = theme;
